import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoadingService, AlertService } from 'ngx-kuv-tools';
import { TipoActualizacionService } from '../tipo-actualizacion.service';

@Component({
  selector: 'app-tipo-actualizacion-update',
  templateUrl: './tipo-actualizacion-update.component.html',
  styles: [
  ]
})
export class TipoActualizacionUpdateComponent implements OnInit {

  form: FormGroup = new FormGroup({});;
  @Input() element: any = null;

  constructor(
    private formBuilder: FormBuilder,
    public loading: LoadingService,
    private alerts: AlertService,
    public activeModal: NgbActiveModal,
    public service: TipoActualizacionService
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      nombre: [null, [Validators.required]],
      descripcion: [null],
      id: [null]
    });

    this.form.patchValue({
      id: this.element.id,
      nombre: this.element.nombre,
      descripcion: (this.element.descripcion) ? this.element.descripcion : null,
    });
  }

  guardar(): void {
    if (this.form.valid) {
      this.loading.show();
      this.service.update(this.form.value).subscribe({
        next: (res) => {
          this.loading.hide();
          this.activeModal.close(res.model);
          this.alerts.addAlert("Tipo de Actualización actualizado con éxito.", "success");
        },
        error: (err) => {
          console.error(err);
          this.loading.hide();
          this.alerts.addAlert("No se pudo actualizar el registro de tipo de actualización.", "danger");
          if (err.error.msg) {
            this.alerts.addAlert(err.error.msg, "danger");
          }
          if (err.error.errors[0]) {
            this.alerts.addAlert(err.error.errors[0].msg, "danger");
          }
        }
      });
    } else {
      this.form.markAllAsTouched();
      this.alerts.addAlert("Hay errores en el formulario.", "warning");
    }
  }
}
